import React from "react";
import { useTheme } from "../context/ThemeContext";

export default function ThemeVariables() {
  const { theme } = useTheme();

  return (
    <style>
      {`
                :root {
                    /* Colors */
                    --color-primary-bg: ${theme.colors.primaryBG};
                    --color-primary: ${theme.colors.primary};
                    --color-secondary: ${theme.colors.secondary};
                    --color-gray-footer: ${theme.colors.grayFooter};
                    --color-text-bg: ${theme.colors.textBG};

                    /* Fonts */
                    --font-nastaleeq-kasheeda: ${theme.fonts.nastaleeqKasheeda};
                    --font-nastaleeq-regular: ${theme.fonts.nastaleeqRegular};
                    --font-al-majeed: ${theme.fonts.alMajeed};
                }
            `}
    </style>
  );
}
